// Screens that are reachable by URL and deliberately absent from the nav, and
// that are not markdown pages in a doc tree.
//
// `/terms` was a page on docs.curri.com rather than a doc, and it keeps a path
// that something outside this repo already names: it appears in a published
// OpenAPI document.

export type UnlistedRouteId = 'terms'

const ROUTES: Record<string, UnlistedRouteId> = {
  '/terms': 'terms',
}

export const unlistedRouteFor = (pathname: string): UnlistedRouteId | null => {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname
  return ROUTES[path] ?? null
}
